/* Copyright (c) 2018 Verge Technologies
 * @file carousel.js
 * @author F. Loreggian
 * Carousel component developed by Fabio Loreggian.
 * This variant has been edited by Brenton Watt to not mutate state.
 */

import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import CarouselRadio from './carousel-radio';

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlideIndex: 0,
      slides: this.props.slides,
      isHover: false,
    };
  }

  componentDidMount() {
    this.setTimer();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  /**
   * Reset timer and set timer
   */
  setTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(() => this.autoSlideChanger(), 30000);
  };

  /**
   * Automate the slider.
   */
  autoSlideChanger = () => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('Carousel Timer');
    }
    const { activeSlideIndex, slides, isHover } = this.state;
    const index = (activeSlideIndex + 1 >= slides.length) ? 0 : activeSlideIndex + 1;
    if (!isHover) {
      this.changeSlide(index);
    }
  }

  /**
   * Open a link when the banner is clicked, also checks if the link is external
   * @param {string} link - The link that is the suspect.
   * @returns {undefined}
   */
  openLink = (link) => {
    const externalLink = /(www)|(http)/;
    if (link.match(externalLink).length) {
      window.open(link, '_blank');
    } else {
      this.props.history.push(link); 
    }
  }

  /**
   * Change active image on carousel.
   * @param {number} index - Index of image to make active on carousel.
   * @returns {*}
   */
  changeSlide = (index) => {
    if (this.state.slides.length) {
      const currentIndex = this.state.activeSlideIndex;
      const directionClassOut = `deactive ${(this.state.activeSlideIndex - index) > 0 ? 'right' : 'left'}`;
      const directionClassIn = `active ${(this.state.activeSlideIndex - index) > 0 ? 'left' : 'right'}`;
      const slides = this.state.slides.slice();
      slides[currentIndex] = {
        ...slides[currentIndex],
        className: directionClassOut,
      };
      slides[index] = {
        ...slides[index],
        className: directionClassIn,
      };
      this.setState({
        slides,
        activeSlideIndex: index,
      });
      this.setTimer();
    }
    return this;
  }

  render() {
    return (
      <div className="carousel">
        <CarouselRadio
          index={this.state.activeSlideIndex}
          size={this.state.slides.length}
          selectSlide={index => this.changeSlide(index)}
        />
        <div className="list">
          {
            this.state.slides.map((slide, slideIndex) => {
              if (slideIndex === this.state.activeSlideIndex) {
                return (
                  <div style={{ position: 'relative' }}>
                    <img
                      key={slideIndex}
                      className={`item ${slide.className}`}
                      src={slide.background_image}
                      style={{
                        width: '100%',
                        height: '100%',
                        cursor: (slide.link && !slide.show_button) ? 'pointer' : '',
                      }}
                      onClick={() => (slide.link && !slide.show_button) ? this.openLink(slide.link) : null}
                      onMouseEnter={() => this.setState({ isHover: true })}
                      onMouseLeave={() => this.setState({ isHover: false })}
                    >
                    </img>
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', justifyContent: 'center', backgroundColor: 'rgba(0, 77, 169, 0.25)' }}>
                      <div className="home-content">
                        <div style={{ textAlign: 'center' }}>
                          <h3 className="hide-when-small" style={{ textTransform: 'capitalize' }}>{slide.heading}</h3>
                          <p className="hide-when-medium" style={{ textTransform: 'capitalize' }}>{slide.subheading}</p>
                          {
                            (slide.link && slide.show_button) && (
                              <span onClick={() => this.openLink(slide.link)} className="button hide-when-medium" style={{ textTransform: 'uppercase' }}>
                                {slide.button_text || 'Learn More'}
                              </span>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
              return null;
            })
          }
        </div>
      </div>
    );
  }
}

Carousel.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default withRouter(Carousel);



// WEBPACK FOOTER //
// ./src/components/Carousel/carousel.js